import { EMeasureUnit } from '../../commomTypes';

// Action Types
export enum Types {
  LOAD_FROM_LOCAL_STORAGE = 'longSteelShoppingCart/LOAD_FROM_LOCAL_STORAGE',
  UPDATE_SHOPPING_CART_SETTINGS = 'longSteelShoppingCart/UPDATE_SHOPPING_CART_SETTINGS',

  FINISH_ORDER = 'longSteelShoppingCart/FINISH_ORDER',
  FINISH_ORDER_SUCCESS = 'longSteelShoppingCart/FINISH_ORDER_SUCCESS',
  FINISH_ORDER_FAILURE = 'longSteelShoppingCart/FINISH_ORDER_FAILURE',

  CLEAN_SHOPPING_CART = 'longSteelShoppingCart/CLEAN_SHOPPING_CART',

  UPDATE_TYPE_OF_ORDER = 'longSteelShoppingCart/UPDATE_TYPE_OF_ORDER',

  UPDATE_TAGGING_INFO_PREVIOUS_SCREEN = 'longSteelShoppingCart/UPDATE_TAGGING_INFO_PREVIOUS_SCREEN'
}

export interface ILongSteelShoppingCartState {
  emitterId: string;
  receiverId: string;
  customerOrder: string;
  items: ILongSteelOrderItem[];

  finishOrderLoading?: boolean;
  finishOrderError?: boolean;
  createdOrders?: string[];
  typeOfOrder: string;
  screenName: string;
  itemDescription: string;
}

export interface ILongSteelOrderItem {
  addedToCart?: boolean;
  code?: string;
  tableId?: number;
  customerSku: string;
  message: string;
  description: string;
  desiredDate: string;
  incoterms: string;
  itemWeb: string;
  measureUnit: EMeasureUnit | string;
  quantity: number;
  sku: string;
  destinations: IDestination[];
  found: boolean;
  customerPurchaseItem?: string;
  itemSaleInfo: IItemSaleInfo;
  preValidation?: {
    field: string;
    type: string;
    message: string;
  };
}

export interface IDestination {
  paymentTerms: IPaymentTerm[];
  measureUnits: IMeasureUnit[];
  fiscalBenefits: IFiscalBenefit[] | undefined;
  company: string;
  description: string;
  distributionChannel: string;
  division: string;
  minimumDate: string;
  multiPlant: boolean;
  plant: string;
  plantDescription: string;
  salesGroup: string;
  salesOffice: string;
  salesOrg: string;
  condGroup: string;
}

export interface IFiscalBenefit {
  code: string;
  description: string;
}

export interface IPaymentTerm {
  description: string;
  term: string;
}

export interface IMeasureUnit {
  convMeasureKg: string; // "1"
  convMeasureTo: string; // "0,001"
  measure: EMeasureUnit; // "KG"
  minimumQuantity: string; // "0.000"
  multiple: string; // "1000.000"
}

export interface IItemSaleInfo {
  sku?: string;
  activitySector?: string;
  benefit?: string;
  distrChannel?: number;
  industrialType?: string | undefined;
  material?: string;
  plant?: number;
  quantity?: string;
  requiredDate?: string;
  salesGroup?: string;
  salesOffice?: string;
  salesOrg?: string;
  term?: string;
  unityMeasure?: EMeasureUnit | string;
  multipleQuantity?: string;
  minimumQuantity?: string;
  customerPurchaseItem?: string;
  consumptionOrder?: string | undefined;
  selectedDestination?: IDestination;
}
